import { PROJECTS_ADD } from '../../routes/path';
import { getProjectsPage } from '../../services/projects/ProjectService';

/**
 * Where a user goes right after logging in. `isNewAccount` only says it is the user's FIRST login —
 * which a member who joined an existing team also has — so the project wizard is the destination only
 * when the account really has no projects yet; otherwise it is `fallback` (the projects list, or the
 * address the user was sent from). Any failure to find out keeps the old behaviour: the wizard.
 */
export const postLoginPath = async <T extends string>(
  isNewAccount: boolean | undefined,
  fallback: T
): Promise<T | typeof PROJECTS_ADD> => {
  if (!isNewAccount) {
    return fallback;
  }
  try {
    // The account's own projects only (no demo project): one row is enough, `total` is the count.
    const { total } = await getProjectsPage({ page: 0, pageSize: 1, accountOnly: true });
    return total > 0 ? fallback : PROJECTS_ADD;
  } catch {
    return PROJECTS_ADD;
  }
};
